const videoCarousel = $ => {
	const breakpoint = 768;
	let lastWidth = window.innerWidth;
	const $carousel = $( '#featured-videos .feed-wrapper.count-3' );

	const initCarousel = () => {
		$carousel.slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			arrows: true
		} );
	};

	const destroyCarousel = () => {
		$carousel.slick( 'unslick' );
	};

	const resize = () => {
		const currentWidth = window.innerWidth;
		const expanding = currentWidth > lastWidth ? true : false;
		let crossBreakpoint = false;

		if ( expanding && currentWidth >= breakpoint && lastWidth < breakpoint ) {
			crossBreakpoint = true;
		}

		if ( ! expanding && currentWidth < breakpoint && lastWidth >= breakpoint ) {
			crossBreakpoint = true;
		}

		if ( expanding && crossBreakpoint ) {
			destroyCarousel();
		}

		if ( ! expanding && crossBreakpoint ) {
			initCarousel();
		}

		lastWidth = currentWidth;
	};

	return {
		init() {
			if ( lastWidth < breakpoint ) {
				initCarousel();
			}

			this.bind();
		},
		bind() {
			$( window ).resize( resize );
		}
	};
};

videoCarousel( jQuery ).init();

const pageAnimations = $ => {
	let windowScrollPos = $( window ).scrollTop();
	let windowHeight = $( window ).height();

	const animate = () => {
		$( '[data-animatable="default"]' ).each( function() {
			const position = $( this ).offset().top;

			if ( windowScrollPos + windowHeight - 300 > position ) {
				$( this ).addClass( 'animated' ).attr( 'data-animatable', 'completed' );
			}
		} );
	};

	return {
		init() {
			animate();
			this.bind();
		},
		bind() {
			if ( $( 'body' ).hasClass( 'home' ) ) {
				$( 'body' ).on( 'scroll', () => {
					windowScrollPos = $( window ).scrollTop();
					windowHeight = $( window ).height();
					animate();
				} );

				$( window ).on( 'resize', () => {
					windowScrollPos = $( window ).scrollTop();
					windowHeight = $( window ).height();
					animate();
				} );
			}
		}
	};
};

pageAnimations( jQuery ).init();
